const KIOSK_PAYU_FLAG = String(process.env.REACT_APP_USE_KIOSK_WRAPPER_PAYU || '').trim().toLowerCase();

function isKioskPayuEnabled() {
    return KIOSK_PAYU_FLAG === '1' || KIOSK_PAYU_FLAG === 'true' || KIOSK_PAYU_FLAG === 'yes';
}

function resolveKioskBridge() {
    if (typeof window === 'undefined') return null;
    return window.KioskBridge || window.kioskBridge || null;
}

export function isKioskBridgeAvailable() {
    return Boolean(resolveKioskBridge());
}

export async function getKioskRuntimeConfig() {
    const bridge = resolveKioskBridge();
    if (!bridge || typeof bridge.getConfig !== 'function') {
        return {
            isElectron: false,
            adminExitConfigured: false,
            kioskId: process.env.REACT_APP_KIOSK_ID || null
        };
    }

    try {
        return await bridge.getConfig();
    } catch (_error) {
        return {
            isElectron: false,
            adminExitConfigured: false,
            kioskId: process.env.REACT_APP_KIOSK_ID || null
        };
    }
}

export async function requestKioskAdminExit() {
    const bridge = resolveKioskBridge();
    if (!bridge || typeof bridge.requestAdminExit !== 'function') {
        return { ok: false, reason: 'bridge-unavailable' };
    }

    try {
        return await bridge.requestAdminExit();
    } catch (error) {
        return {
            ok: false,
            reason: error?.message || 'request-failed'
        };
    }
}

export function subscribeToKioskSystemEvents(callback) {
    const bridge = resolveKioskBridge();
    if (!bridge || typeof bridge.onSystemEvent !== 'function') {
        return () => {};
    }

    return bridge.onSystemEvent(callback);
}

export function launchPayuInKioskWrapper(params) {
    if (!isKioskPayuEnabled()) {
        return false;
    }

    const bridge = resolveKioskBridge();
    if (bridge && typeof bridge.launchPayuCheckout === 'function') {
        bridge.launchPayuCheckout(params);
        return true;
    }

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('kiosk:payu-launch', { detail: params }));
        return true;
    }

    return false;
}

export function isKioskWrapperPayuEnabled() {
    return isKioskPayuEnabled();
}

export async function launchExternalJourneyInKioskWrapper(params) {
    const bridge = resolveKioskBridge();
    if (!bridge || typeof bridge.launchExternalJourney !== 'function') {
        return { ok: false, reason: 'bridge-unavailable' };
    }

    try {
        return await bridge.launchExternalJourney(params);
    } catch (error) {
        return {
            ok: false,
            reason: error?.message || 'request-failed'
        };
    }
}

export async function generateSanctionLetterPdfInKioskWrapper(params) {
    const bridge = resolveKioskBridge();
    if (!bridge || typeof bridge.generateSanctionLetterPdf !== 'function') {
        return { ok: false, reason: 'bridge-unavailable' };
    }

    try {
        return await bridge.generateSanctionLetterPdf(params);
    } catch (error) {
        return {
            ok: false,
            reason: error?.message || 'request-failed'
        };
    }
}
